import { useEffect, useState } from "react";
import ApiAmusementService from "../../../core/api/api.amusementService";
import _ from "lodash";
import { Col, Row, Alert } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import DataGrid from "./DataGrid";
import EditAmusementServiceDescription from "./EditModal";
import SwalMessage from "../_Components/SwalMessage";
import Swal from "sweetalert2";
import SelectComponent from "../_Components/ReactSelectComponent";

const AmusementDescription = () => {
  const [services, setServices] = useState([]);
  const [selectedServiceId, setSelectedServiceId] = useState(0);
  const [listData, setListData] = useState({ data: [] });
  const [showModalUpdateDescription, setShowModalUpdateDescription] = useState(false);
  const [formInputs, setFormInputs] = useState({ service: null });
  const [selectedServiceItemDescription, setSelectedServiceItemDescription] = useState(null);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});

  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(data)) {
          setServices(data);
        }
      } catch (e) {
      }
    };
    fetchServices();
  }, []);

  // دزیافت دوباره اطلاعات سرویس هنگام حذف شدن یا آپدیت شدن
  const fetchAmusementServiceDescriptions = async () => {
    if (selectedServiceId && selectedServiceId != 0) {
      const response = await ApiAmusementService.getReserveDetails({ id: selectedServiceId });
      const descriptionsObject = JSON.parse(response.reserveDetail_V2Descriptions);
      setListData({ data: descriptionsObject });
    }
    else
      setListData({ data: [] });
  };

  // دریافت مجدد اطلاعات سرویس هنگام عوض شدنش
  useEffect(() => {
    (async () => {
      fetchAmusementServiceDescriptions();
    })();
  }, [selectedServiceId]);

  const inputChangeHandler2 = (selectedOption) => {
    setSelectedServiceId(selectedOption.value);
    setFormInputs({ service: selectedOption });
  };

  async function deleteMessage(item) {
    Swal.fire({
      title: "عملیات حذف توضیح",
      text: "ایا قصد حذف این توضیح را دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        deleteApi(item);
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  }

  async function deleteApi(item) {
    try {
      const response = await ApiAmusementService.deleteAmusementServiceDescription({
        amusementId: selectedServiceId,
        id: item.id,
      });
      if (response.succeeded == true) fetchAmusementServiceDescriptions();
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  }

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت توضیحات فرم رزرو</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست توضیحات ثبت شده برای هر فرم رزرو</span>
          </h3>
          <div className="card-toolbar"></div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3">
          {/* search box */}
          <div className="border-top pt-3">
            <Row className="mb-3">
              <Col xs="12" className="mt-3">
                <SelectComponent
                  className="mt-0"
                  placeholder="انتخاب سرویس"
                  options={services.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                  value={formInputs.service || ""}
                  onChange={inputChangeHandler2}
                />
              </Col>
              <Col xs="12" className="mt-5">
                <FormProvider {...methods}>
                  {selectedServiceId !== 0 && listData?.data !== null && (
                    <Col xs="12" className="tb-reponsive px-0">
                      <DataGrid
                        deleteMessage={deleteMessage}
                        data={listData}
                        setShowModalUpdateDescription={setShowModalUpdateDescription}
                        setSelectedServiceItemDescription={setSelectedServiceItemDescription}
                      />
                    </Col>
                  )}

                  {(listData?.data === null || listData?.data === undefined) && (
                    <Col xs="12" className="tb-reponsive px-0">
                      <div className="px-8 mt-4">
                        <Alert variant="secondary">توضیحی برای این تفریح وجود ندارد</Alert>
                      </div>
                    </Col>
                  )}

                  {showModalUpdateDescription && (
                    <EditAmusementServiceDescription
                      showModalUpdateDescription={showModalUpdateDescription}
                      setShowModalUpdateDescription={setShowModalUpdateDescription}
                      selectedServiceItemDescription={selectedServiceItemDescription}
                      selectedServiceId={selectedServiceId}
                      fetchAmusementServiceDescriptions={fetchAmusementServiceDescriptions}
                    />
                  )}
                </FormProvider>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmusementDescription;
